import { Entity } from '@/store/shared/entity'
export default class EstimatedExchangeRate extends Entity<number>{
    month:Date;
    year:Date;
    dateTime:string;
    estimatedExchangeRates:number;
}